import React, { useState } from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import Markdown from "markdown-to-jsx";
import { TextLoader } from "components/Loader";
import { VIDEO_INTERVIEW_CONTENT_PREVIEW_LENGTH } from "constants/index";
import { colors, fontSize } from "style";
import { shortenText } from "utils";
import { PrimaryLink } from "components/Links";

/**
 * ProfileVideoInterviewContentSection
 *
 * @param {Boolean} loading
 * @param {String}  title
 * @param {String}  content
 * @param {String}  emptyMessageId
 * @param {Boolean} shortenContent
 */
const ProfileVideoInterviewContentSection = ({ loading, title, content, emptyMessageId, shortenContent = false }) => {
  const isLongContent = shortenContent && (content?.length || 0) > VIDEO_INTERVIEW_CONTENT_PREVIEW_LENGTH;
  const [expanded, setExpanded] = useState(false);

  if (loading) {
    return (
      <>
        <TextLoader width="100%" height="1rem" />
        <TextLoader width="100%" height="1rem" />
        <TextLoader width="60%" height="1rem" />
      </>
    );
  }

  return (
    <>
      <div css={styles.title}>{title}</div>
      <div css={styles.text}>
        {content ? (
          <Markdown>
            {expanded || !isLongContent ? content : shortenText(content, VIDEO_INTERVIEW_CONTENT_PREVIEW_LENGTH)}
          </Markdown>
        ) : (
          <FormattedMessage id={emptyMessageId} />
        )}
        {content && isLongContent && (
          <PrimaryLink css={styles.show_more_button} onClick={() => setExpanded((current) => !current)}>
            <FormattedMessage id={expanded ? "Global.ShowLess" : "Global.ShowMore"} />
          </PrimaryLink>
        )}
      </div>
    </>
  );
};

const styles = {
  title: css`
    font-size: ${fontSize.normal};
    font-weight: 500;
  `,
  text: css`
    font-size: ${fontSize.small};
    line-height: 1.5;
    white-space: pre-wrap;
    color: ${colors.grayAnatomyDark};
    margin-top: 0.5rem;
  `,
  show_more_button: css`
    margin-left: 0.75rem;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
  `,
};

ProfileVideoInterviewContentSection.propTypes = {
  loading: PropTypes.bool,
  title: PropTypes.node,
  content: PropTypes.string,
  emptyMessageId: PropTypes.string,
  shortenContent: PropTypes.bool,
};

export default ProfileVideoInterviewContentSection;
